export default __webpack_public_path__ + "static/media/yoga.b4e73ba6.svg";